<template>
    <tr>
        <td>#{{ invoice.id }}</td>
        <td>{{ invoice.issued_date }}</td>
        <td>{{ getCurrency }}{{ invoice.balance_due - invoice.paid_amount < 0 ? 0 : invoice.balance_due - invoice.paid_amount | formatNumber }}</td>
        <td>{{ getCurrency }}{{ invoice.paid_amount | formatNumber }}</td>
        <td>
            <div class="select is-fullwidth">
                <select v-model="deposit" v-on:change="depositPayment()">
                    <option selected :value="null" disabled>Deposit</option>
                    <option value="100%">Pay in full</option>
                    <option value="50%-50%">50%</option>
                    <option value="30%-70%">30%</option>
                </select>
            </div>
        </td>
    </tr>
</template>

<script>

    export default {
        props: ['invoice', 'transactionTotals'],
        components: {

        },
        data() {
            return {
                //deposit: this.invoice.deposit_payment
            }
        },
        methods: {
            depositPayment(){
                if(this.deposit == '100%'){
                    this.invoice.paid_amount = this.invoice.sub_total
                }else if(this.deposit == '50%-50%'){
                    this.invoice.paid_amount = this.invoice.sub_total * 50/100
                }else if(this.deposit == '30%-70%'){
                    this.invoice.paid_amount = this.invoice.sub_total * 30/100
                }
                this.$store.dispatch('paymentDepositInvoice', {transaction_id: this.$route.params.id, multi_invoice_id: this.invoice.id, deposit: this.deposit, paid_amount: this.invoice.paid_amount})
            }
        },
        computed: {
            deposit: {
                get(){
                    return this.invoice.deposit_payment;
                },
                set(value){
                    this.invoice.deposit_payment = value;
                }
            },
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Balance-Statement/UnpaidClientMultiInvoiceTableRow.vue